import React from "react";
import CostRow from "./exp-cost-row";
import { calculateCostAccommodation, exchangeRate } from "./cost-helper";

const AccommodationRow = ({guideData, expData}) => {
    // Check if this is a REBEL villa (flat fee) or traditional accommodation (per attendee)
    const isVilla = expData.villaRentalFee !== undefined && expData.villaRentalFee.value !== undefined;
    const attendees = parseFloat(guideData.attendees?.value) || 1;

    // For REBEL villas: calculateCostAccommodation returns FLAT TOTAL (not per attendee)
    // For traditional: calculateCostAccommodation returns per-attendee cost
    const accommodationCost = calculateCostAccommodation(guideData, expData);

    // Calculate per-attendee and total costs based on type
    const perAttendeeCost = isVilla ? accommodationCost / attendees : accommodationCost;
    const totalAccommodationCost = isVilla ? accommodationCost : accommodationCost * attendees;

    return (
        <React.Fragment>
            <CostRow title="Accommodation"
                    icon='bed'
                    single
                    currency={guideData.currency.value.slice(3)}
                    costPer={(expData, Number(totalAccommodationCost/guideData.tripLength.value))}
                    perLabel="per night"
                    num={guideData.tripLength.value}
                    type="nights"
                    subtotal={perAttendeeCost}
                    attendees={attendees}
                    //message={"Let's pop a message here."}
                    accommodation={expData}
                    exchangeRate={exchangeRate}
                    villaSubtotal={isVilla ? totalAccommodationCost : undefined}
            />
        </React.Fragment>
    )
}

export default AccommodationRow;